var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallMetaModelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    rx: 18,
    fill: "#FF6666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5992 82.3924C71.9754 83.3286 75.7907 84.2347 79.0249 82.3091L79.3029 82.1524C82.3694 80.3136 83.7586 76.8341 84.103 74.4497L84.288 32.9361C86.0292 25.6473 92.8228 25.5096 96.0019 26.3518L138.344 50.3028C143.107 53.4776 140.382 58.0304 138.493 59.0923L109.602 75.8924L109.124 112.641C108.199 118.581 105.531 121.112 102.764 122.672C100.182 124.128 96.4251 124.74 90.9542 122.651L58.1292 104.681L28.7863 120.717C26.9 121.784 21.5009 121.812 21.067 116.196L21 68.4076C21.8427 65.2976 25.3616 59.6204 32.6954 61.7921L69.5992 82.3924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMetaModelLogo);
export default __webpack_public_path__ + "static/media/SmallMetaModelLogo.60c029825d96ba32c9d176a306bfb992.svg";
export { ForwardRef as ReactComponent };